export default ({ savedItems }) =>
  savedItems.indicatives.items ||
  savedItems.items.map(savedItem => ({
    ...savedItem,
    ...savedItem.indicatives
  }));
